import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CarePathwayStep } from '../../../../services/result-data/result-data.service';
import { MatIconModule } from '@angular/material/icon';

type StepperVariant = 'global' | 'in-step';

@Component({
  selector: 'app-care-pathway-stepper',
  imports: [MatIconModule],
  templateUrl: './care-pathway-stepper.component.html',
  styleUrl: './care-pathway-stepper.component.scss',
})
export class CarePathwayStepperComponent {
  /** The steps to display */
  @Input() steps: CarePathwayStep[] = [];
  /** Selected index (only used by minimal variant for highlighting) */
  @Input() selectedIndex: number | null = null;
  /** global = big centered with titles; in-step = compact bottom-left bar */
  @Input() variant: StepperVariant = 'global';

  @Output() stepSelected = new EventEmitter<number>();

  onClick(i: number) {
    this.stepSelected.emit(i);
  }
}
